import React from 'react';
import { Row, Col, Typography } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const { Title } = Typography;

const collaboratorsData = [
  { id: 1, name: "Google", logo: "/images/partners/google.png", url: "https://www.google.com" },
  { id: 2, name: "Microsoft", logo: "/images/partners/microsoft.png", url: "https://www.microsoft.com" },
  { id: 3, name: "AWS", logo: "/images/partners/aws.png", url: "https://aws.amazon.com" },
  { id: 4, name: "Cohere", logo: "/images/partners/cohere.png", url: "https://cohere.ai" },
  { id: 5, name: "ForGoodLab", logo: "/images/partners/forgoodlab.png", url: "https://forgoodlab.com" },
  { id: 6, name: "Google Cloud", logo: "/images/partners/googlecloud.png", url: "https://cloud.google.com" },
  { id: 7, name: "Hugging Face", logo: "/images/partners/huggingface.png", url: "https://huggingface.co" },
  { id: 8, name: "Lamini", logo: "/images/partners/lamini.png", url: "https://www.lamini.ai" },
  { id: 9, name: "LangChain", logo: "/images/partners/langchain.png", url: "https://langchain.com" },
  { id: 10, name: "OpenAI", logo: "/images/partners/openai.png", url: "https://openai.com" },
  { id: 11, name: "Stanford Online", logo: "/images/partners/stanfordonline.png", url: "https://online.stanford.edu" },
  { id: 12, name: "Coursera", logo: "/images/partners/coursera.png", url: "https://www.coursera.org" },
  { id: 13, name: "Weights & Biases", logo: "/images/partners/weights.png", url: "https://wandb.ai" },
];

const CollaboratorsSection = () => {
  const handleImageError = (e) => {
    e.target.src = '/images/placeholder.jpg';
  };

  return (
    <Row gutter={16}>
      <Col span={24}>
        <section style={{ marginBottom: '40px' }}>
          <Title level={2} style={{ fontSize: '18px', textAlign: 'center', color: '#1890ff', textTransform: 'uppercase' }}>
            In Collaboration With
          </Title>
          <div style={{ margin: '20px 0' }}>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={3}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              style={{ padding: '0 20px' }}
            >
              {collaboratorsData.map((collaborator) => (
                <SwiperSlide key={collaborator.id} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <a href={collaborator.url} target="_blank" rel="noopener noreferrer" title={`Visit ${collaborator.name}`}>
                    <img
                      src={collaborator.logo}
                      alt={`Logo of ${collaborator.name}, a collaborator of JectHub`}
                      onError={handleImageError}
                      style={{ maxWidth: '150px', maxHeight: '100px', objectFit: 'contain' }}
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      </Col>
    </Row>
  );
};

export default CollaboratorsSection;